import { render, staticRenderFns } from "./DashboardDeliveries.vue?vue&type=template&id=114ada84&"
import script from "./DashboardDeliveries.vue?vue&type=script&lang=js&"
export * from "./DashboardDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports